// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__h3Le9","blockUp":"LoginPage_blockUp__v-qMR","blockDown":"LoginPage_blockDown__zPnXh"};